import { METADATA_SYNC } from "../Action"

const initialState = {}

export default function (state = initialState, action) {
  switch(action.type) {
    case METADATA_SYNC: return { ...state, ...action.payload};
    default: return state;
  }
}